import api from './api';

// Company types based on API response (company table)
export interface Company {
  id: string;
  name: string;
  address?: string;
  contact?: string;
  phone?: string;
  email?: string;
  createTime?: string;
  updateTime?: string;
  createBy?: string;
  updateBy?: string;
}

export interface CompanyListParams {
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface CompanyCreateData {
  name: string;
  address?: string;
  contact?: string;
  phone?: string;
  email?: string;
  description?: string;
}

export interface CompanyUpdateData {
  name?: string;
  address?: string;
  contact?: string;
  phone?: string;
  email?: string;
  description?: string;
}

export interface PaginatedCompanyResponse {
  items: Company[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

const companyService = {
  /**
   * List all companies (filtered by tenant mapping for Tenant Admins)
   */
  list: async (params?: CompanyListParams) => {
    const response = await api.get('/companies', { params });
    return response.data as PaginatedCompanyResponse;
  },

  /**
   * Get company by ID
   */
  getById: async (id: string) => {
    const response = await api.get(`/companies/${id}`);
    return response.data as Company;
  },

  /**
   * Create new company
   */
  create: async (data: CompanyCreateData) => {
    const response = await api.post('/companies', data);
    return response.data as Company;
  },

  /**
   * Update company
   */
  update: async (id: string, data: CompanyUpdateData) => {
    const response = await api.put(`/companies/${id}`, data);
    return response.data as Company;
  },

  /**
   * Delete company
   */
  delete: async (id: string) => {
    await api.delete(`/companies/${id}`);
  },
};

export default companyService;
